import { Link } from "react-router-dom";
import { PenLine, ArrowRight } from "lucide-react";
import { useMember } from "@/context/MemberContext";

export const WriteLetterCta = ({ electorate, compact = false }) => {
  const { member } = useMember();
  return (
    <Link to="/write" data-testid="write-letter-cta" className={`group block rounded-2xl border border-[#FDFBF7]/15 bg-[#1B2A41]/70 backdrop-blur hover:border-[#E2705A] transition-colors ${compact ? "p-4" : "p-5 sm:p-6"}`}>
      <div className="flex items-start gap-4">
        <span className="w-11 h-11 rounded-xl bg-[#E2705A] text-white flex items-center justify-center flex-shrink-0"><PenLine className="w-5 h-5" /></span>
        <div className="min-w-0 flex-1">
          <p className="font-type text-[11px] uppercase tracking-[0.3em] text-[#8FA58A]">F.E.R.M letter</p>
          <h3 className="font-type font-bold text-base md:text-lg text-[#FDFBF7] mt-1 leading-snug">Write to your federal member{electorate ? ` for ${electorate}` : ""}</h3>
          <p className="text-xs text-[#FDFBF7]/70 mt-1.5 leading-relaxed">
            {member ? "Your letter is pre-filled — sitting member or candidate, add one local matter, then send it from your own email." : "F.E.R.Ms get a pre-filled letter to their sitting member or a candidate. Not a F.E.R.M yet? You'll join first, then the letter opens."}
          </p>
          <span className="mt-3 inline-flex items-center gap-1.5 text-xs font-type font-bold uppercase tracking-wider text-[#E2705A] group-hover:gap-2.5 transition-all">{member ? "Open my letter" : "Sign in or join to start"} <ArrowRight className="w-3.5 h-3.5" /></span>
        </div>
      </div>
    </Link>
  );
};
